import { render, staticRenderFns } from "./StoreRoleForm.vue?vue&type=template&id=71e88582&"
import script from "./StoreRoleForm.vue?vue&type=script&lang=js&"
export * from "./StoreRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports